interface HttpError extends ErrorConstructor {
  message: string;
  response: any;
  status: number;
}

const fetcherWithToken = async (
  url: string,
  token: string,
  init?: RequestInit
) => {
  return fetch(url, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      ...init?.headers,
    },
  }).then(async (r) => {
    if (r.ok) {
      return r.json().catch(() => r.text);
    } else {
      let err = new Error(
        `Call to ${url} failed with HTTP status code: " ${r.status}`
      ) as HttpError;
      err.response = r;
      err.status = r.status;
      err.message = await r.text();
      throw err;
    }
  });
};

export default fetcherWithToken;
